module.exports = __webpack_public_path__ + "static/media/exhsmall3.36eafe0a.png";